angular.module('mtic.components.select_box', [])
.directive('selectBox', function ($log, EventManager, $timeout, TeacherDataService, PlatformService) {
  return {
    templateUrl: 'template.html',
    scope: {
      options: '=',
      model: '=',
      fillerText: '=?',
      displayFunction: '=?',
      onChange: '=?',
      noWidth: '=?',
      clickableFiller: '=?',
      isViewSwitch: '=?',
      showToggle: '=?'
    },
    link: function (scope, $el) {
      var eventManager = new EventManager('selectBox');
      scope.selection_clicked = false;
      var clicked = false;

      scope.ipadToggleCheck = function(){
        if(PlatformService.isIos){
          if(scope.selection_clicked){
            hide_options()
          }else{
            scope.show_options()
          }
        }
      }

      scope.show_options = function(){
        if(!scope.selection_clicked){
          clicked = true;
        }
        scope.selection_clicked = true;
        document.addEventListener('pointerdown', hide_options_proxy)
        document.addEventListener("mousedown", hide_options_proxy);
        document.addEventListener('touchstart', hide_options_proxy) // for iOS safari
        $timeout(()=>{
          clicked = false
        }, 50)
      }

      function hide_options(){
        if(clicked){
          return;
        }
        $timeout(()=>{
          scope.selection_clicked = false;
          document.removeEventListener('pointerdown', hide_options_proxy)
          document.removeEventListener("mousedown", hide_options_proxy);
          document.removeEventListener('touchstart', hide_options_proxy) // for iOS safari
        }, 200)
      }

      function hide_options_proxy(e){
        scope.$apply(()=>{
          if(!$el[0].querySelector('.selectBox__options').contains(e.srcElement)){
            hide_options()
          }
        })
      }

      scope.set_option = function(option, dont_stop){
        hide_options();
        if(scope.isViewSwitch && TeacherDataService.inTeacherAgendaView && !dont_stop){
          eventManager.broadcast('request_agenda_change', {class_change: true, class_id: option});
          return;
        }
        scope.model = option;
      }

      eventManager.listen('agenda_class_change_request_granted', function(e, args){
        scope.set_option(args, true);
      })

      scope.clear_option = function(){
        if(scope.clickableFiller){
          scope.set_option();
        }
      }

      scope.display = function(option){
        if(scope.displayFunction && option){
          if( typeof scope.displayFunction === 'string'){
            return option[scope.displayFunction];
          }else{
            return scope.displayFunction(option);
          }
        }else{
          return option;
        }
      }

      if(scope.onChange){
        scope.$watch('model', (val)=>{
          //$log.log('model', scope.model)
          scope.onChange(val);
        })
      }
    }
  }
})
